module.exports = __webpack_public_path__ + "img/dunaint4.a281e7fd.png";